import { useMutation, useQueryClient } from '@tanstack/react-query';

import { oprApi } from '~/shared/services/api';

import {
  FEATURE_FLAGS_QUERY_KEY,
  GLOBAL_FEATURE_FLAGS_QUERY_KEY,
} from './useGetFeatureFlags';

type PatchFeatureFlagDto = {
  isEnabled: boolean;
  id: string;
};

type FeatureFlagResponse = {
  id: string;
  status: boolean;
  name: string;
  description: string;
};

function patchFeatureFlag(data: PatchFeatureFlagDto) {
  return oprApi.patch<FeatureFlagResponse>(
    `feature-flag-management/${data.id}`,
    {
      isEnabled: data.isEnabled,
    }
  );
}

export function usePatchFeatureFlag() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: patchFeatureFlag,
    async onSuccess() {
      await Promise.all([
        queryClient.invalidateQueries([FEATURE_FLAGS_QUERY_KEY], {
          exact: false,
        }),
        queryClient.invalidateQueries([GLOBAL_FEATURE_FLAGS_QUERY_KEY], {
          exact: false,
        }),
      ]);
    },
  });
}
